var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 7.17654C7.03749 7.17654 6.24399 6.86428 5.61947 6.23977C4.99496 5.61525 4.6827 4.82175 4.6827 3.85927C4.6827 2.89037 4.99496 2.09526 5.61947 1.47394C6.24399 0.852642 7.03749 0.541992 7.99997 0.541992C8.96246 0.541992 9.75596 0.852642 10.3805 1.47394C11.005 2.09526 11.3172 2.89037 11.3172 3.85927C11.3172 4.82175 11.005 5.61525 10.3805 6.23977C9.75596 6.86428 8.96246 7.17654 7.99997 7.17654ZM0.5 14.8073V12.9092C0.5 12.3721 0.642308 11.9041 0.926925 11.5054C1.21154 11.1067 1.58142 10.8003 2.03655 10.5862C3.0891 10.1182 4.10383 9.76568 5.08075 9.52849C6.05767 9.29133 7.03074 9.17274 7.99997 9.17274C8.96921 9.17274 9.93972 9.29389 10.9115 9.53619C11.8833 9.77849 12.8955 10.1285 13.948 10.5862C14.4134 10.8003 14.7884 11.1067 15.073 11.5054C15.3576 11.9041 15.5 12.3721 15.5 12.9092V14.8073H0.5Z",
    fill: "#565660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8eebf4e9314b6eea6d3a82ae853695a2.svg";
export { ForwardRef as ReactComponent };